import {getAssetUrl} from '@Utils/s3.util';

export interface LoginSignupPromoCarouselProps {
  doesReferrerExist: boolean;
}

export interface PromoCarouselSlideContent {
  headingFirstLineLangKey: string;
  headingSecondLineLangKey: string;
  imageUrl: string;
  isImageWidthCapped: boolean;
}

export interface PromoCarouselAutoAdvanceOptions {
  activeSlideIndex: number;
  isPaused: boolean;
  advanceToNextSlide: VoidFunction;
}

export const PROMO_CAROUSEL_SLIDES: PromoCarouselSlideContent[] = [
  {
    headingFirstLineLangKey: 'pmwjs_create_instant',
    headingSecondLineLangKey: 'pmwjs_designs_with_ai',
    imageUrl: getAssetUrl('ai-chat-login-page-promo-img-1.webp'),
    isImageWidthCapped: true,
  },
  {
    headingFirstLineLangKey: 'pmwjs_brainstorm_ideas_with',
    headingSecondLineLangKey: 'pmwjs_ai_for_your_business',
    imageUrl: getAssetUrl('ai-chat-login-page-promo-img-2.webp'),
    isImageWidthCapped: false,
  },
  {
    headingFirstLineLangKey: 'pmwjs_transform_designs',
    headingSecondLineLangKey: 'pmwjs_like_a_pro_with_ai',
    imageUrl: getAssetUrl('ai-chat-login-page-promo-img-3.webp'),
    isImageWidthCapped: false,
  },
];

export const FIRST_SLIDE_INDEX = 0;
export const PROMO_CAROUSEL_AUTO_ADVANCE_DELAY_MS = 4000;
export const REDUCED_MOTION_MEDIA_QUERY = '(prefers-reduced-motion: reduce)';
export const LOGIN_PAGE_LOGO_ASSET_NAME = 'postermywall-login-page-logo.png';
